import { createRoot } from '@wordpress/element';
import { useState } from 'react';

// Deep import (not the '@/components' barrel): the barrel re-exports TypographyEdit,
// which drags @wordpress/block-editor + framer-motion + ariakit into this frontend
// bundle. Importing Collapsible directly keeps the payload to radix-collapsible.
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
} from '@/components/Сollapsible/Сollapsible';

import styles from '../faq-item/edit.module.scss';

interface FaqItemData {
  triggerHTML: string;
  contentHTML: string;
}

function FaqAccordion({ items }: { items: FaqItemData[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <>
      {items.map((item, index) => (
        <div
          key={index}
          className={`wp-block-interact-faq-item ${styles.faqItem}`}
          data-hydrated="true"
        >
          <Collapsible
            open={openIndex === index}
            onOpenChange={(open) => setOpenIndex(open ? index : null)}
          >
            <CollapsibleTrigger
              className={styles.trigger}
              dangerouslySetInnerHTML={{ __html: item.triggerHTML }}
            />
            <CollapsibleContent>
              <div
                className={styles.content}
                dangerouslySetInnerHTML={{ __html: item.contentHTML }}
              />
            </CollapsibleContent>
          </Collapsible>
        </div>
      ))}
    </>
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const faqItemsContainers = document.querySelectorAll('.wp-block-interact-faq-items');

  faqItemsContainers.forEach((container) => {
    const faqItems = container.querySelectorAll(`.${styles.faqItem}[data-hydrated="false"]`);

    if (faqItems.length === 0) return;

    const items: FaqItemData[] = [];

    faqItems.forEach((faqItem) => {
      const trigger = faqItem.querySelector(`.${styles.trigger}`) as HTMLElement;
      const content = faqItem.querySelector(`.${styles.content}`) as HTMLElement;

      if (trigger && content) {
        // Backfill a label on FAQ blocks saved before the aria-label was added.
        const roundButton = trigger.querySelector('.round-button');
        if (roundButton && !roundButton.getAttribute('aria-label')) {
          roundButton.setAttribute('aria-label', 'Toggle answer');
        }

        items.push({
          triggerHTML: trigger.innerHTML,
          contentHTML: content.innerHTML,
        });
      }
    });

    if (items.length === 0) return;

    container.innerHTML = '';

    const root = createRoot(container);
    root.render(<FaqAccordion items={items} />);
  });
});
